// removed by extract-text-webpack-plugin
module.exports = {"MultiselectColumn":"MultiselectColumn--14VGw","HeaderCell":"HeaderCell--2D1MB"};


//////////////////
// WEBPACK FOOTER
// ./src/app/components/Pages/Columns/MultiselectColumn/MultiselectColumn.local.css
// module id = 963
// module chunks = 1